<template>
  <Start />
</template>
<script route="/fin/process_control">
  import Start from './index.jsx';
  export default {
    components: { Start }
  }
</script>
